import React from "react";

const Footer = () => {
  return (
    <footer className="footer mt-auto">
      <p>© {new Date().getFullYear()} GLM. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
